module.exports = [{"id":1,"done":false,"text":"Behandler oplysninger"},{"id":2,"done":false,"text":"Finder forsikringer"},{"id":3,"done":false,"text":"Tilpasser"}]


//////////////////
// WEBPACK FOOTER
// ./src/entities/progressStates.json
// module id = mXkr
// module chunks = 0